import {LOCATION_CHANGE} from 'connected-react-router';

const ACTIONS = {
    NAVIGATE: 'ROUTER/NAVIGATE',
    LOCATION_CHANGE
};

const ACTION_CREATORS = {
    navigate(updatedParams, options = {}) {
        /* istanbul ignore next */
        return {
            type: ACTIONS.NAVIGATE,
            payload: {updatedParams, options}
        };
    },
    navigateToModal(modalRoute, type = 'push') {
        return {
            type: ACTIONS.NAVIGATE,
            payload: {
                updatedParams: {
                    r: modalRoute
                },
                options: {
                    persist: true,
                    type
                }
            }
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
